import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import '@/App.css';
import { Toaster } from '@/components/ui/sonner';
import ConnectivityBanner from '@/components/ConnectivityBanner';
import IosInstallPrompt from '@/components/IosInstallPrompt';
import LandingPage from '@/pages/LandingPage';
import MerchantDashboard from '@/pages/MerchantDashboard';
import CustomerDashboard from '@/pages/CustomerDashboard';
import VerifyPage from '@/pages/VerifyPage';
import AdminLogin from '@/pages/AdminLogin';
import AdminDashboard from '@/pages/AdminDashboard_New';
import AdminKycReviewPage from '@/pages/AdminKycReviewPage';
import AgentLogin from '@/pages/AgentLogin';
import AgentDashboard from '@/pages/AgentDashboard';
import AgentGrantPayoutPage from '@/pages/AgentGrantPayoutPage';
import KycUploadPage from '@/pages/KycUploadPage';
import PasskeySettings from '@/pages/PasskeySettings';
import PasskeyRecoveryPage from '@/pages/PasskeyRecoveryPage';

function App() {
  return (
    <div className="App">
      <ConnectivityBanner />
      <IosInstallPrompt />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/verify" element={<VerifyPage />} />
          <Route path="/merchant/*" element={<MerchantDashboard />} />
          <Route path="/customer/kyc" element={<KycUploadPage />} />
          <Route path="/customer/passkeys" element={<PasskeySettings />} />
          <Route path="/customer/*" element={<CustomerDashboard />} />
          <Route path="/recovery" element={<PasskeyRecoveryPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/kyc" element={<AdminKycReviewPage />} />
          <Route path="/agent/login" element={<AgentLogin />} />
          <Route path="/agent/dashboard" element={<AgentDashboard />} />
          <Route path="/agent/grant-payout" element={<AgentGrantPayoutPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
